import { FunctionComponent } from 'react'

import { Grid } from '@material-ui/core'
import { colors } from 'shared/styles/colors'
import { Message, StyledClose, TitleModal } from './styles'
import Button from 'shared/components/Button'
import Modal from 'shared/components/Modal'

type TProps = {
  openModal: boolean
  closeModal: () => void
}

const ModalErro: FunctionComponent<TProps> = ({ openModal, closeModal }) => {
  return (
    <Modal
      openModal={openModal}
      curvature={true}
      showCloseButton={true}
      onCloseModal={closeModal}
    >
      <Grid
        md={12}
        container
        spacing={2}
        justifyContent="space-between"
        alignItems="center"
        style={{ textAlign: 'center', height: '100%' }}
      >
        <Grid container alignItems="center" justify="center" spacing={4}>
          <Grid item>
            <StyledClose />
          </Grid>
        </Grid>
        <TitleModal>Erro ao gerar boleto</TitleModal>
        <Grid container item>
          <Message>
            Infelizmente não foi possível gerar esse boleto, tente novamente
            mais tarde.
          </Message>
        </Grid>
        <Grid container style={{ width: '100%' }}>
          <Button
            color={colors.green}
            onClick={closeModal}
            style={{ width: '100%' }}
          >
            Entendi
          </Button>
        </Grid>
      </Grid>
    </Modal>
  )
}

export default ModalErro
